/* AGEGATE_ASSET_BUILD: 2026-02-07_03 */
(function () {
  // Debug marker to verify asset actually loaded
  window.__AGEGATE_ASSET_LOADED__ = Date.now();

  function getCookie(name) {
    if (!name) return null;
    const safe = name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1");
    const m = document.cookie.match(new RegExp("(^|;\\s*)" + safe + "=([^;]+)"));
    return m ? decodeURIComponent(m[2]) : null;
  }

function setCookie(name, value, hours, path) {
  if (!name) return;
  if (!hours || hours <= 0) return; // 0 => always show

  const maxAge = Math.max(1, Math.floor(hours * 3600));
  const secure = location.protocol === "https:" ? "; Secure" : "";

  document.cookie =
    name + "=" + encodeURIComponent(value) +
    "; Max-Age=" + maxAge +
    "; Path=" + (path || "/") +
    "; SameSite=Lax" +
    secure;
}


  function initOverlay(overlay) {
    if (!overlay || overlay.dataset.ageGateInit === "1") return;
    overlay.dataset.ageGateInit = "1";
    overlay.dataset.ageGateBoot = String(Date.now()); // <-- what you were checking

    // Read settings from data-* (set by Liquid in the section)
    const cookieName  = (overlay.dataset.cookieName || "age_gate_verified").trim();
    const expiryHours = Number(overlay.dataset.expiryHours || "0");
    const lockScroll  = overlay.dataset.lockScroll === "true";
    const blockBackdropClose = overlay.dataset.blockBackdropClose === "true";
    const cookiePath  = (overlay.dataset.cookiePath || "/").trim();
    const noRedirect  = overlay.dataset.noRedirect || "https://google.com";

    // Preview mode: ONLY respect the section setting.
    // (Do NOT auto-force preview via Shopify.previewMode, or it will always show in preview.)
    const previewMode = (overlay.dataset.previewMode === "true");

    function show() {
      overlay.classList.add("age-gate--active");
      overlay.style.setProperty("display", "flex", "important");
      if (lockScroll) document.body.classList.add("age-gate-locked");
    }

    function hide() {
      overlay.classList.remove("age-gate--active");
      overlay.style.setProperty("display", "none", "important");
      document.body.classList.remove("age-gate-locked");
    }

    const verified = getCookie(cookieName);

    console.log("[AgeGate][asset]", {
      id: overlay.id, cookieName, verified, previewMode, expiryHours
    });

    if (!previewMode && verified === "yes") return;

    show();

    const yesBtn = overlay.querySelector("[data-age-gate-yes]");
    const noBtn  = overlay.querySelector("[data-age-gate-no]");

    if (yesBtn && !yesBtn.dataset.bound) {
      yesBtn.dataset.bound = "1";
      yesBtn.addEventListener("click", function () {
        setCookie(cookieName, "yes", expiryHours, cookiePath);
        hide();
      });
    }

    if (noBtn && !noBtn.dataset.bound) {
      noBtn.dataset.bound = "1";
      noBtn.addEventListener("click", function () {
        window.location.href = noRedirect;
      });
    }

    if (blockBackdropClose && !overlay.dataset.backdropBound) {
      overlay.dataset.backdropBound = "1";
      overlay.addEventListener("click", function (e) {
        const panel = overlay.querySelector(".age-gate__panel");
        if (panel && !panel.contains(e.target)) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }
  }

  function scan() {
    document.querySelectorAll('[id^="age-gate-"]').forEach(initOverlay);
  }

  // Run on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  // Run on bfcache / back
  window.addEventListener("pageshow", scan);

  // Run when theme editor reloads sections
  document.addEventListener("shopify:section:load", scan);
  document.addEventListener("shopify:section:select", scan);

  // Run when your theme injects HTML dynamically (this is the big one)
  const mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
